import styled from "styled-components"

export default function ListBox({title, TitleIcon = null, subtitle, list, Component, style, headerMargin, noBorder = false}) {
  const noBorderStyle = {boxShadow: "0 0 0 0", borderRadius: 0, padding: 0, backgroundColor: "#FFFFFF00"}
  
  return (
    <Box 
      style={{
        ...(noBorder ? noBorderStyle : {}),
        ...style, 
      }}
    >
      {title &&
        <BoxHeader
          style={{margin: headerMargin}}
        >
          <BoxTitle>
            {title}
          </BoxTitle>
          { TitleIcon }
        </BoxHeader>
      }

      {subtitle &&
        <BoxSubtitle>
          {subtitle}
        </BoxSubtitle>
      }

      {
        list.map(item => 
          <Component {...item}/>
        )
      }
    </Box>
  )
}

const Box = styled.div`
  padding-left: 25px; 
  padding-right: 12px;
  padding-top: 26px;
  padding-bottom: 25px;

  margin-left: 23px;
  margin-right: 22px;

  background-color: #FFFFFF;

  border-radius: 15px;
  box-shadow: 0px 10px 8px 0px #0000001F;
`

const BoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const BoxTitle = styled.p`
  font-family: Abraham, Bold;
  font-weight: 600;
  font-size: 22px;
  margin: 0;
`

const BoxSubtitle = styled.p`
  font-family: Abraham, Regular;
  font-size: 19px;
  font-weight: 500;
  color: #1A1A1A;
`